import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist/es/constants";
import storage from "redux-persist/lib/storage";
import authReducer from "./authSlice";
import breadcrumbReducer from "./breadcrumbSlice";
import companyReducer from "./companySlice";
import userSettingsReducer from "./userSettingsSlice";

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  userSettings: userSettingsReducer,
  company: companyReducer,
  breadcrumb: breadcrumbReducer,
});

// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "company", "breadcrumb"], // Persist only these states
};

// Apply persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredActionPaths: ["register", "rehydrate"],
        ignoredPaths: ["persist"],
      },
    }),
});

// Define AppDispatch type
export type AppDispatch = typeof store.dispatch;

// Persistor
export const persistor = persistStore(store);
